import { createSlice } from "@reduxjs/toolkit";
export var createSlicePrototype = function(param) {
    var name = param.name;
    var initialState = {
        data: null,
        isFetching: false,
        isError: false
    };
    var slice = createSlice({
        name: name,
        initialState: initialState,
        reducers: {
            fetchData: function(state) {
                state.isFetching = true;
                state.data = null;
                state.isError = false;
            },
            fetchDataSuccess: function(state, action) {
                state.isFetching = false;
                state.data = action.payload;
            },
            fetchDataFailure: function(state) {
                state.isFetching = false;
                state.isError = true;
            },
            resetState: function() {
                return initialState;
            }
        }
    });
    return slice;
};
